import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getDashboardName } from "../../API/API";

function* getUserTagSaga(action) {
  try {
    const response = yield call(() => getDashboardName(action));
    yield put({
      type: types.FETCH_USER_TAG_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_USER_TAG_FAILURE, 
      payload: error.response ? error.response.data : error.message,
    });
  }
}

export function* watchGetUserTagSaga() {
  yield takeEvery(types.FETCH_USER_TAG_REQUEST, getUserTagSaga);
}
